let swiper2 = new Swiper('.mySwiper', {
  direction: 'horizontal',
  loop: true,
slidesPerView: 6,
  autoplay:true,
  
  

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints:{
       0: {
      slidesPerView: 2,
      spaceBetween: 20
    },

    480: {
      slidesPerView: 3,
      spaceBetween: 30
    },

    768: {
      slidesPerView: 4,
      spaceBetween: 40
    },
      1200: {
        slidesPerView: 6,
          spaceBetween: 60
      }
  }    

});

 